module.exports = __webpack_public_path__ + "img/sp_webview.2b3a0483.png";